var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: ['t-button-toggle', _vm.baseClass, {
      't-checked': _vm.value
    }],
    attrs: {
      "type": "button",
      "aria-pressed": _vm.value ? 'true' : 'false'
    },
    on: {
      "click": function click($event) {
        return _vm.toggle();
      },
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-left", undefined, $event.key, undefined)) { return null; }
        if (!$event.shiftKey) { return null; }
        $event.stopPropagation();
        return _vm.toggle(false);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-right", undefined, $event.key, undefined)) { return null; }
        if (!$event.shiftKey) { return null; }
        $event.stopPropagation();
        return _vm.toggle(true);
      }]
    }
  }, [_c('span', {
    staticClass: "t-label"
  }, [_c('span', {
    class: ['t-icon-spot', _vm.iconClass],
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "t-label-text"
  }, [_vm._t("default")], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }